module.exports = __webpack_public_path__ + "static/media/zhiyezhuang3.9da4e378.png";